import $ from 'jquery'

function init(element) {
  handleDOMClicks(element)
  $(element)
    .find('.dropdown-widget__toggler')
    .on('click', () => {
      toggleWidget(element)
    })
}

function handleDOMClicks(element) {
  $(document).on('click', (event) => {
    if (!element.contains(event.target)) {
      hideWidget(element)
    }
  })
}

function toggleWidget(widget) {
  let widgetBody = $(widget).find('.dropdown-widget__body')
  if (widgetBody.is(':visible')) {
    hideWidget(widget)
  } else {
    showWidget(widget)
  }
}

function showWidget(widget) {
  $(widget)
    .find('.dropdown-widget__body')
    .fadeIn()
}

function hideAllWidgets() {
  $('.dropdown-widget').each((_, widget) => {
    hideWidget(widget)
  })
}

function hideWidget(widget) {
  $(widget)
    .find('.dropdown-widget__body')
    .fadeOut()
}

export default {
  init,
  showWidget,
  hideAllWidgets
}
